import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { CartProvider } from './context/CartContext';
import { WinesProvider } from './context/WinesContext';
import { LanguageProvider } from './i18n/LanguageContext';
import './styles/master.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <LanguageProvider>
        <WinesProvider>
          <CartProvider>
            <App />
          </CartProvider>
        </WinesProvider>
      </LanguageProvider>
    </BrowserRouter>
  </React.StrictMode>
);
